import React, {
  ReactElement,
  useEffect,
  useLayoutEffect,
  useState,
} from 'react';
import { useParams } from 'react-router-dom';
import { TrainingPorgramsService } from 'services/TrainingProgramService';
import { Utils } from 'shared/helpers';
import TrainingPreviewDialog from '../view-training-programs/components/DialogPreviewTraining';
import { Box, CircularProgress, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { AuthActions } from 'state/authentication/Action';
import { connect } from 'react-redux';

const PreviewTraining = (props: any): ReactElement => {
  const { setValidToken }: any = props;
  const { assignmentId, trainingId } = useParams() as any;
  const [isRecordCategory, setRecordCategory] = useState<boolean>(true);
  const [trainingDetails, setTrainingDetails] = useState<any>([]);
  const [loadingDetails, setLoadingDetails] = useState<boolean>(true);
  const [showComplete, setShowComplete] = useState<boolean>(false);
  const [trainingProgress, setTrainingProgress] = useState<any>([]);

  // Preview Training
  const [open, setOpen] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [quizPassed, setQuizPassed] = useState(false);
  const [, setCompletedSteps] = useState(new Set());

  const loadProgramDetails = (): void => {
    setLoadingDetails(true);
    TrainingPorgramsService.getTrainingProgramDetails(trainingId)
      .then((response) => {
        const { data } = response.data;
        setTrainingDetails(data.program_data);
        setLoadingDetails(false);
        setOpen(true);
      })
      .catch((error) => {
        Utils.handleErrorResponse(error);
      });
  };

  const loadTrainingProgress = (): void => {
    TrainingPorgramsService.getProgressAssignment(assignmentId)
      .then((response) => {
        const { data } = response.data;
        setTrainingProgress(data?.progress);
        setCurrentStep(data?.progress?.currentStepIndex ?? 0);
      })
      .catch((error) => {
        Utils.handleErrorResponse(error);
      });
  };

  const getValidToken = (): void => {
    TrainingPorgramsService.getValidToken(assignmentId)
      .then((response) => {
        const requestToken = new Promise((resolve) => {
          const { data } = response.data;
          const { accessToken, refreshToken } = data;
          setValidToken({
            accessToken,
            refreshToken,
          });
          resolve(true);
        });

        requestToken.then(() => {
          loadTrainingProgress();
          loadProgramDetails();
        });
      })
      .catch((error) => {
        Utils.handleErrorResponse(error);
      });
  };

  const handleComplete = (): void => {
    setShowComplete(true);
  };

  useLayoutEffect(() => {
    if (isRecordCategory) {
      setRecordCategory(false);
    }
  }, [isRecordCategory]);

  useEffect(() => {
    if (assignmentId) {
      getValidToken();
    }
  }, [assignmentId]);

  return (
    <>
      {loadingDetails && !showComplete && (
        <Box
          sx={{
            height: '100vh',
            alignContent: 'center',
            justifySelf: 'center',
            textAlign: 'center',
          }}
        >
          <CircularProgress />
        </Box>
      )}
      {!loadingDetails &&
        !showComplete &&
        trainingDetails?.training_definition?.steps?.length > 0 && (
          <>
            <TrainingPreviewDialog
              open={open}
              setOpen={setOpen}
              currentStep={currentStep}
              setCurrentStep={setCurrentStep}
              quizPassed={quizPassed}
              setQuizPassed={setQuizPassed}
              setCompletedSteps={setCompletedSteps}
              steps={trainingDetails?.training_definition?.steps}
              purpose="external"
              trainingDetails={trainingDetails}
              handleComplete={handleComplete}
              assignmentId={assignmentId}
              trainingProgress={trainingProgress}
            />
          </>
        )}
      {showComplete && (
        <Box
          sx={{
            height: '100vh',
            alignContent: 'center',
            justifySelf: 'center',
            textAlign: 'center',
          }}
        >
          <CheckCircleIcon sx={{ color: '#d1f27a', fontSize: '8rem' }} />
          <Typography
            sx={{
              fontSize: 26,
              fontWeight: 800,
              color: '#3d3c42',
              lineHeight: 1.4,
            }}
            mt={3}
          >
            Congratulations! <br />
            You have completed the training.
          </Typography>
        </Box>
      )}
    </>
  );
};

const mapDispatchToProps = (dispatch: any): any => ({
  setValidToken: (data: any) => dispatch(AuthActions.setLoginStatus(data)),
});

const mapStateToProps = (state: any): any => ({
  authState: state.authState,
});

export default connect(mapStateToProps, mapDispatchToProps)(PreviewTraining);
